import MainInfoStep from './MainInfoStep.component';

export default MainInfoStep;
